<template>
  <div class="jobs">
    <div class="container">
      <div class="row">
        <div class="col s12 m6">
          <div class="title">Jobs I have done.</div>

          <p>
            As a freelancer I have been exposed to several projects all the way
            from small to large scale colaborative projects. This has been a
            good experience to me because I have been able to get the exposure
            on how diffrent projects work and also on their requirements. I have
            tackled some of the projects individually while others as a
            contrubutor in a team of developers. The following are some of the
            projects i have done:
          </p>

          <div class="row">
            <div class="col s6 m4">
              <div class="inner">
                <img
                  @click="go"
                  src="@/assets/vectors/0001.jpg"
                  class="img-responsive img"
                />
              </div>
            </div>
          </div>

          <router-link to="/projects" class="link"
            >See more projects
          </router-link>
        </div>
        <div class="col s12 m6 my">
          <img
            src="@/assets/vectors/jobs2.svg"
            class="img-responsive swing"
            style="animation-delay: 1s"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();

    const go = () => {
      router.push("/projects");
    };
    return {
      go,
    };
  },
};
</script>

<style scoped>
.jobs {
  min-height: 100%;
  /* margin-top: auto; */
  align-items: center;
  justify-content: center;
  margin-top: 75px;
  margin-bottom: 75px;
}
.title {
  font-size: 48px;
  font-weight: 600;
}
.link {
  text-decoration: none;
  font-weight: 600;
  color: #765cd1;
  position: relative;
  display: inline-block;
  background: linear-gradient(to right, #765cd1, midnightblue 50%, #765cd1 50%);
  overflow: hidden;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 275ms ease;
}
.link:hover {
  background-position: 0 100%;
}
.inner {
  overflow: hidden;
  /*border-radius: 10px;*/
  object-fit: cover;
  height: 100px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.img-responsive {
  width: 100%;
  height: auto;
}
.img {
  transition: 1.5s ease-in-out;
  height: 100px;
}
.inner:hover .img {
  transition: 1.5s ease-in-out;
  transform: scale(1.2);
}

span {
  border-bottom: 2px dotted #765cd1;
  font-weight: 600;
}
@media only screen and (max-width: 601px) {
  .my {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}

@-webkit-keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20py);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

@keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20px);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

.swing {
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-animation: swinging 3.5s ease-in-out forwards infinite;
  animation-delay: 2s;
  animation: swinging 3.5s ease-in-out forwards infinite;
}
</style>
